import { GrowthTypes } from '@components/comparison-growth-selector/Types';
import { RelativePeriod } from '@components/comparison-period-selector/Types';
import { Periodicity } from '@components/time-period-selector/PeriodsTypes';
import { BaseTimePeriod } from '@services/FiltersTypes';
import { getSessionStorage, setSessionStorage, StorageKey } from '@utils/StorageUtils';
import { Action, MainFilterTypeProducts } from '@state/actions/Type';

export interface MainFilterStateProducts {
  timeFrame: Periodicity | string;
  period: BaseTimePeriod;
  comparisonPeriod: RelativePeriod | BaseTimePeriod;
  selectedGrowthType: GrowthTypes;
  country: string;
}

const getInitialState = () => {
  const storeProductsMainFilters = JSON.parse(getSessionStorage(StorageKey.ProductsMainFilters) as string);

  if (storeProductsMainFilters !== null) {
    return {
      timeFrame: storeProductsMainFilters.timeFrame,
      period: storeProductsMainFilters.period,
      comparisonPeriod: storeProductsMainFilters.comparisonPeriod,
      selectedGrowthType: storeProductsMainFilters.selectedGrowthType,
      country: storeProductsMainFilters.country,
    };
  }

  return Object.freeze({
    timeFrame: Periodicity.Weekly,
    period: {
      value: '',
      label: '',
      lastUpdatedDate: 0,
    },
    comparisonPeriod: RelativePeriod.PreviousYearCurrentPeriod,
    selectedGrowthType: GrowthTypes.percentage,
    country: '',
  });
};

const MainFiltersProductsReducer = (
  state: MainFilterStateProducts = getInitialState(), //NOSONAR typescript:S1788
  action: Action,
) => {
  if (action.type === MainFilterTypeProducts.MainFiltersUpdatedProducts) {
    const finalPayLoad = {
      ...state,
      ...action.payload,
    };
    setSessionStorage(StorageKey.ProductsMainFilters, JSON.stringify(finalPayLoad));
    return finalPayLoad;
  }
  return state;
};

export default MainFiltersProductsReducer;
